import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {message} from 'antd';
import {SmallPopover, modal} from 'icsoc-antd-ex';
import UnionTableList from 'Components/union/unionTableList';
import CommonTable from 'Components/common/commonTable';
import CircleAudio from 'Components/common/circleAudio';
import IconFont from 'Components/common/iconFont';
import DetailDrawer from 'Components/detailDrawer';
import tQuestionStudyActions from 'Actions/ai/questionStudy';
import sort from 'Utils/sort';
import moment from 'moment';

const {modalTips} = modal;

class TableList extends UnionTableList {
  constructor(props) {
    super(props);

    this.state = {
      isDetailDrawerVisible: false, // 详情抽屉是否可见
      rowId: -1, // 当前点击的表格行id
      detailDrawerLoading: false, // 详情抽屉loading
      tabActiveKey: props.tabActiveKey || '1',
    };
  }

  columns = [
    {
      title: '序号',
      key: 'key',
      dataIndex: 'key',
      width: 60,
      fixed: 'left',
      render: (text, record, index) => {
        const {
          pageStatus: {pageNum, pageSize},
        } = this.props;

        return sort({pageNum, pageSize, index});
      },
    },
    {
      title: '未知问题',
      dataIndex: 'question',
      key: 'question',
      render: text => text || '--',
    },
    {
      title: '录音',
      dataIndex: 'url',
      width: '9%',
      key: 'url',
      render: (text, record) => (
        <CircleAudio source={text} start={record.start} end={record.end} />
      ),
    },
    {
      title: '操作人',
      width: '12%',
      dataIndex: 'updateUser',
      key: 'updateUser',
      render: text => text || '--',
    },
    {
      title: '更新时间',
      dataIndex: 'time',
      width: '17%',
      key: 'time',
      render: (text, record) => {
        const {tabActiveKey} = this.props;
        let str = '';

        switch (parseInt(tabActiveKey, 10)) {
          case 1:
            str = record.createTime;
            break;
          case 2:
            str = record.learnTime;
            break;
          case 3:
            str = record.ignoreTime;
            break;
          default:
            break;
        }

        return (str && moment(str).format('YYYY-MM-DD HH:mm:ss')) || '--';
      },
    },
    {
      title: '操作',
      key: 'operate',
      dataIndex: 'operate',
      width: 100,
      fixed: 'right',
      render: (text, record) => {
        const {tabActiveKey} = this.props;

        return (
          <div className="operate">
            <SmallPopover type="white" content="查看详情" className="tooltip">
              <IconFont
                type="icon-robottasklist"
                onClick={() => {
                  this.showDetailDrawer(record);
                }}
              />
            </SmallPopover>
            {parseInt(tabActiveKey, 10) === 2 ? null : (
              <SmallPopover type="white" content="学习" className="tooltip">
                {
                  this.props.login.permissionsList.includes('questionStudy.study') ?
                  <IconFont
                    type="icon-robotrename"
                    onClick={() => {
                      this.handleAction('study', record.id);
                    }}
                  />
                : null}
              </SmallPopover>
            )}
            {(parseInt(tabActiveKey, 10) === 2 ||
              parseInt(tabActiveKey, 10) === 3) ? null : (
              <SmallPopover type="white" content="忽略" className="tooltip">
                {
                  this.props.login.permissionsList.includes('questionStudy.ignore') ?
                  <IconFont
                    type="icon-robotban"
                    onClick={() => {
                      this.handleAction('ignore', record.id);
                    }}
                  />
                : null}
              </SmallPopover>
            )}
          </div>
        );
      },
    },
  ];

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.tabActiveKey !== prevState.tabActiveKey) {
      return {
        tabActiveKey: nextProps.tabActiveKey,
      };
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState) {
    const {tabActiveKey} = this.state;

    if (tabActiveKey !== prevState.tabActiveKey) {
      this.closeDetailDrawer();
    }
  }

  handleAction = (type, id) => {
    const {
      actions,
      setTableListLoading,
      pageStatus: {pageNum, pageSize},
      tableListData: {total = 0} = {},
    } = this.props;

    setTableListLoading();
    actions[type](id).then(res => {
      const {payload: {code = ''} = {}} = res || {};

      if (parseInt(code, 10) === 200) {
        const newPageNum = Math.ceil((total - 1) / pageSize);
        const turnPageNum = pageNum < newPageNum ? pageNum : newPageNum || 1;

        this.setPageStatus({
          pageNum: turnPageNum,
        });

        if (type === 'ignore') {
          this.handleIgnoreAction(turnPageNum);
        } else {
          this.handleStudyAction(turnPageNum);
        }
      }
    });
  };

  // 学习
  handleStudyAction = turnPageNum => {
    const {
      getTableList,
      searchData,
      pageStatus: {pageSize},
    } = this.props;

    modalTips({
      centered: true,
      type: 'success',
      mode: 'simple',
      width: 380,
      title: '已学习，请尽快到语料库中维护该问题',
      onOk: () => {
        getTableList(
          {
            ...searchData,
            pageNum: turnPageNum,
            pageSize,
          },
          'withoutLoading',
        );
      },
    });
  };

  // 忽略
  handleIgnoreAction = turnPageNum => {
    const {
      getTableList,
      searchData,
      pageStatus: {pageSize},
    } = this.props;

    message.success('忽略成功');
    getTableList(
      {
        ...searchData,
        pageNum: turnPageNum,
        pageSize,
      },
      'withoutLoading',
    );
  };

  // 显示通话详情抽屉
  showDetailDrawer = (record, type) => {
    const {actions} = this.props;

    if (type !== 'onRow') {
      this.setState({
        isDetailDrawerVisible: true,
      });
    }
    this.setState({
      rowId: record.id,
      detailDrawerLoading: true,
    });

    actions.getDetailDrawerData(record.callTaskInfoId).finally(() => {
      this.setState({
        detailDrawerLoading: false,
      });
    });
  };

  // 关闭通话详情抽屉
  closeDetailDrawer = () => {
    this.setState({
      rowId: -1,
      isDetailDrawerVisible: false,
    });
  };

  render() {
    const {
      tableListData: {data = [], total = 0} = {},
      loading,
      pageStatus: {pageNum, pageSize},
      detailDrawerData,
    } = this.props;
    const {
      rowId,
      isDetailDrawerVisible,
      detailDrawerLoading,
      tabActiveKey,
    } = this.state;
    let currentColumns = this.columns;
    if (parseInt(tabActiveKey, 10) === 1) {
      currentColumns = this.columns.filter(item => item.title !== '操作人');
    }

    return (
      <React.Fragment>
        <CommonTable
          columns={currentColumns}
          dataSource={[...data]}
          rowKey="id"
          loading={loading}
          extraHeight={48}
          scroll={{x: 960}}
          onChange={this.handleTableChange}
          pagination={{
            current: pageNum,
            total: total && parseInt(total, 10),
            pageSize,
            showTotal: () => `共 ${total} 条`,
          }}
          rowClassName={record => (rowId === record.id ? 'row-back' : '')}
          onRow={record => ({
            onClick: data => {
              if (
                data.target &&
                data.target.tagName !== 'use' &&
                data.target.tagName !== 'svg' &&
                isDetailDrawerVisible
              ) {
                this.showDetailDrawer(record, 'onRow');
              }
            },
          })}
        />

        {isDetailDrawerVisible ? (
          <DetailDrawer
            pageType="quesStudy"
            id={rowId}
            loading={detailDrawerLoading}
            dataSource={detailDrawerData}
            onClose={this.closeDetailDrawer}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({aiQuestionStudy,login}) => ({
  tableListData: aiQuestionStudy.tableListData,
  pageStatus: aiQuestionStudy.pageStatus,
  tabActiveKey: aiQuestionStudy.tabActiveKey,
  searchData: aiQuestionStudy.searchData,
  detailDrawerData: aiQuestionStudy.detailDrawerData,
  login
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tQuestionStudyActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableList);
